// eslint-disable-next-line no-unused-vars
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  Container, Row,
} from 'react-bootstrap';
import { LinearProgress } from '@material-ui/core';
import SaleStore from '../../stores/SaleStore';
import DefaultTable from '../common/Tables/DefaultTable';
import AlertTemplate from '../common/AlertTemplate';

class SaleApp extends Component {
  async componentDidMount() {
    try {
      await SaleStore.loadItems();
    } catch (e) {
      console.log(e.message);
      SaleStore.set('alert', {
        show: true,
        variant: 'danger',
        msg: `Error! ${e.message}`,
      });
    } finally {
      console.log('finally');
    }
  }

  render() {
    return (
      <Container>
        {SaleStore.loading && <LinearProgress variant="query" />}
        <AlertTemplate alert={SaleStore.alert} setShow={SaleStore.set} />
        <Row >
          <h2> Test</h2>
         <DefaultTable items={SaleStore.items} tableHead={SaleStore.listHead}/>
        </Row>
      </Container>
    );
  }
}

export default observer(SaleApp);
